import { useState, useEffect, useRef } from 'react';

export default function AnimNum({value,prefix="$"}){
  const [n,setN]=useState(0);const raf=useRef(null);
  useEffect(()=>{
    const start=Date.now(),dur=1300;
    const tick=()=>{const p=Math.min((Date.now()-start)/dur,1);setN(Math.round(value*(1-Math.pow(1-p,3))));if(p<1)raf.current=requestAnimationFrame(tick);};
    raf.current=requestAnimationFrame(tick);return()=>cancelAnimationFrame(raf.current);
  },[value]);
  return <span>{prefix}{n.toLocaleString()}</span>;
}
